<template>
  <div class="owpi-loader-item">
    <div class="wbx-skeleton owpi-loader-item__image"></div>

    <div class="owpi-loader-item__content">
      <div class="wbx-skeleton owpi-loader-item__text"></div>
      <div class="wbx-skeleton owpi-loader-item__text"></div>
      <div class="wbx-skeleton owpi-loader-item__text"></div>
    </div>
  </div>
</template>

<style lang="scss">
.owpi-loader-item {
  gap: var(--wb-spacing-xs);

  display: flex;
  align-items: center;

  &__image,
  &__text {
    width: 100%;
    height: 100%;
    display: block;
  }

  &__image {
    flex-grow: 1;
    flex-shrink: 0;
    width: 118px;
    height: 118px;

    @include wb.breakpoint-between(mq3, mq5) {
      width: 90px;
      height: 90px;
    }

    @include wb.breakpoint-from(mq5) {
      width: 156px;
      height: 156px;
    }
  }

  &__content {
    width: 100%;

    @include utils.grid(8, false, 16px);

    @include wb.breakpoint-from(mq3) {
      @include utils.grid(10, false, 16px);
    }

    @include wb.breakpoint-from(mq5) {
      @include utils.grid(12, false, 16px);
    }
  }

  &__text {
    @include utils.grid-cell(8);

    height: 16px;

    &:nth-of-type(2) {
      @include utils.grid-cell(4);
    }

    &:last-of-type {
      display: none;
    }

    @include wb.breakpoint-from(mq3) {
      @include utils.grid-cell(9);

      &:nth-of-type(2) {
        @include utils.grid-cell(3);
      }
    }

    @include wb.breakpoint-from(mq5) {
      &,
      &:nth-of-type(2) {
        @include utils.grid-cell(12);
      }

      &:last-of-type {
        @include utils.grid-cell(4);

        display: block;
      }
    }
  }
}
</style>
